import {FC} from 'react'

import {legalStrings} from '../../legal/legal-helpers'
import {LegalInline} from './legal-inline'
import {useLegalLang} from './use-legal-lang'

/** The checkout sentence of the kit: Exsportia Terms, Privacy policy and the venue's cancellation policy. */
export const CheckoutAgreement: FC = () => {
  const lang = useLegalLang()
  return (
    <span lang={lang}>
      <LegalInline
        text={legalStrings(lang).checkoutAgree}
        newTab
      />
    </span>
  )
}
